<template>
	<div class="upload_kuang">
		<draggable v-model="list" :group="group" chosenClass="chosen" handle=".rank" forceFallback="true" animation="400" @update="datadragEnd">
			<transition-group class="upload_kuang">
				<div class="upload_item" v-for="(item,index) in list" :key="index+'asd'">
					<el-image :src="name==''?item:item[name]" class="upload_image" :preview-src-list="preview_list" fit="contain"></el-image>
					<div class="upload_actions" @click="del(item,index)"><i class="el-icon-delete"></i></div>
					<div class="upload_actions rank">
						<i class="el-icon-rank"></i>
					</div>
				</div>
			</transition-group>
		</draggable>
		<el-upload class="upload_item" drag :action="action" :headers="headers" :accept="accept" multiple :show-file-list="false" :before-upload="before_upload" :on-success="on_success">
			<i class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
	components: {
        draggable,
    },
	name: 'uploads',
	data() {
		return {
			action:process.env.API_ROOT+'upload/uploadImage',
			headers:{
				"Authorization": "Bearer "+ sessionStorage.getItem('token'),
				'Accept': 'application/json, text/plain, */*'
			},
			loading:null,
			list:[],
			preview_list:[],
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default:()=>[]
		},
		accept: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		group: {
			type: String,
			default: ''
		}
	},
	watch: {
		'value': {
		    immediate: true,
		    handler:function(list){
				this.list=list;
				var preview_list=[];
				for (var i = 0; i < list.length; i++) {
					preview_list[i] = this.name ? list[i][this.name] : list[i];
				}
				this.preview_list=preview_list;
		    }
		},
	},
	mounted() {},
	methods: {
		on_success(res){
			if (res.code==0) {
				var list = this.list;
				if(this.name){
					list.push({[this.name]:res.data});
				}else{
					list.push(res.data)
				}
	            this.$emit('callback', list);
				this.$message.success('上传成功');
			}else{
				this.$message.error(res.msg);
			}
			this.loading.close();
		},
		before_upload(file){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
        del(data,index){
        	this.removeByIndex(this.list,index);
			this.$emit('callback',this.list);
        },
        datadragEnd(evt){
            evt.preventDefault();
            var checkMenusList = [];
            var list=this.list;
            for (var i = 0; i < list.length; i++) {
            	checkMenusList.push(list[i]);
            }
            this.list=checkMenusList;
			this.$emit('callback',list);
        }
	}
}
</script>
<style scoped>
.upload_kuang{
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px;
	user-select: none;
}
.upload_kuang .upload_item{
	width: 100px;
	height: 100px;
	position: relative;
}
.upload_kuang .upload_item /deep/ .el-upload .el-upload-dragger,
.upload_kuang .upload_item .upload_image{
	width: 100%;
	height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.upload_kuang .upload_item /deep/ .el-upload{
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
}
.upload_kuang .upload_item .upload_actions{
	width: 40%;
	height: 40%;
	position: absolute;
	left: 0;
	top: 0;
	background:rgba(0, 0, 0, .5);
	transition: opacity .3s;
	opacity: 0;
	display: flex;
	justify-content: center;
    align-items: center;
    cursor: pointer;
}
.upload_kuang .upload_item .upload_actions.rank{
	right: 0;
	left: auto;
}
.upload_kuang .upload_item .upload_actions:hover{
	opacity: 1;
}
.upload_kuang .upload_item .upload_actions i{
	font-size: 20px;
	color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/uploads.vue